import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const ROLE_LABELS = { yonetici: "Yönetici", muhasebeci: "Muhasebeci", muhasebe_stj: "Muhasebe Stj.", junior_muhasebe: "Junior Muhasebe", personel: "Personel" };
const FLAGS = [["canSeeTahsilatTotal", "Tahsilat"], ["canSeeVekaletTotal", "Vekalet"]];

export function SummaryFlagsControl({ onChanged }) {
  const [roles, setRoles] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/tahsilat-settings/summary-flags").then((r) => setRoles(r.data.roles)).catch(() => setRoles({}));
  }, []);

  const toggle = async (role, flag) => {
    setSaving(true);
    try {
      const r = await api.put("/tahsilat-settings/summary-flags", { role, flag, value: !roles[role][flag] });
      setRoles(r.data.roles);
      toast.success("Özet görünürlüğü güncellendi");
      onChanged?.();
    } catch {
      toast.error("Güncellenemedi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid="tahsilat-dashboard-visibility-btn" title="Tahsilat ve vekalet toplamlarını hangi roller görsün?"
          className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-600 hover:text-slate-900 bg-white border border-slate-200 hover:border-slate-300 px-2.5 py-1 rounded-full transition-colors">
          <Eye size={12} /> Özet Görünürlüğü
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-3" data-testid="tahsilat-dashboard-visibility-panel">
        <div className="text-xs font-bold text-slate-900 mb-1">Tahsilat & vekalet toplamları</div>
        <div className="text-[11px] text-slate-500 mb-2">Yönetici her zaman görür. Kullanıcı Yetkileri'nden de değiştirilebilir.</div>
        {roles === null ? (
          <div className="text-xs text-slate-400">Yükleniyor...</div>
        ) : (
          <table className="w-full text-xs">
            <thead>
              <tr className="text-slate-500">
                <th className="text-left font-semibold py-1">Rol</th>
                {FLAGS.map(([, l]) => <th key={l} className="font-semibold py-1 text-center">{l}</th>)}
              </tr>
            </thead>
            <tbody>
              {Object.entries(ROLE_LABELS).map(([role, label]) => (
                <tr key={role} className="border-t border-slate-100">
                  <td className="py-1.5 text-slate-800">{label}</td>
                  {FLAGS.map(([flag]) => (
                    <td key={flag} className="text-center">
                      <input type="checkbox" checked={!!roles[role]?.[flag]} disabled={saving}
                        onChange={() => toggle(role, flag)} data-testid={`summary-flag-${role}-${flag}`} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </PopoverContent>
    </Popover>
  );
}
